import React, { PureComponent } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Col, Row, Button, Label } from "reactstrap";
import Select from "react-select";
import { translate, textTranslate } from "../../utils/i18n";
import * as deviceActions from "../../redux/actions/deviceActions";
import * as organizationsActions from "../../redux/actions/organizationsActions";

import * as i18nActions from "../../redux/actions/i18nActions";
import * as dashboardActions from "../../redux/actions/dashboardActions";
import { flattenDeep, intersection, intersectionBy, intersectionWith, includes, some, uniq, uniqBy } from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
class AdvancedFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFilterOpen: false,
      selectedOrganizationList: [],
      selectedDeviceModelsList: [],
      selectedDeviceTypeCategories: [],
      devicesModelsList: [],
      selectedDevicesList: [],
    };
  }

  getOrganizationDevices = (organization) => {
    let _selectedDevicesList = [];
    organization.devices.forEach((deviceID) => {
      this.props.devices.forEach((d) => {
        if (d._id === deviceID) _selectedDevicesList.push(d);
      });
    });

    this.setState({
      selectedDevicesList: [..._selectedDevicesList],
    });
    return _selectedDevicesList;
  };

  handleSelectOrganizationsOptionsChange = (selectedOrganizationsOptions) => {
    for (let index = 0; index < selectedOrganizationsOptions.length; index++) {
      const organization = selectedOrganizationsOptions[index];
      if (organization.devices.length <= 0) {
        toast.error(translate("organizationHasnoDevices"));
        selectedOrganizationsOptions.splice(index, 1);
      }
    }
    this.setState({
      selectedOrganizationList: [...selectedOrganizationsOptions],
    });

    let selectedDeviceTypeCategories = [];
    let selectedDevicesModels = [];
    let _selectedDevicesList =
      this.state.selectedDevicesList.length !== 0 ? [...this.state.selectedDevicesList] : [...this.props.devicesList];
    if (selectedOrganizationsOptions.length < 1) return this.handleClearDevicesFilters(true);

    console.log("before selectedDeviceTypeCategories", selectedDeviceTypeCategories);
    _selectedDevicesList = flattenDeep([
      ...selectedOrganizationsOptions.map((organization) => this.getOrganizationDevices(organization)),
    ]);

    _selectedDevicesList.forEach((device) => {
      if (!some(selectedDeviceTypeCategories, device.device_model.deviceTypeCategory)) {
        selectedDeviceTypeCategories.push(
          this.props.deviceTypeCategories.find((t) => t._id === device.device_model.deviceTypeCategory._id)
        );
      }
    });

    // _selectedDevicesList.forEach((device) => {
    //   if (
    //     !some(
    //       selectedDeviceTypeCategories,
    //       device.device_model.deviceTypeCategory,
    //       (a) => a._id === device.device_model.deviceTypeCategory._id
    //     )
    //   ) {
    //     selectedDeviceTypeCategories.push(device.device_model.deviceTypeCategory);
    //   }
    // });

    //  this.props.devicesModels.forEach((deviceModel) => {
    //    if (device.device_model._id === deviceModel._id)
    //      if (selectedDevicesModels.indexOf(deviceModel) === -1) selectedDevicesModels.push(deviceModel);
    //  });
    console.log("after selectedDeviceTypeCategories", selectedDeviceTypeCategories);
    this.setState({
      selectedDevicesList: [..._selectedDevicesList],
      devicesModelsList: [...selectedDevicesModels],

      selectedDeviceModelsList: [...[...intersection(this.state.selectedDeviceModelsList, selectedDevicesModels)]],
    });
    this.props.setSelectedDeviceTypeCategories(selectedDeviceTypeCategories);
    this.props.SetSelectedDevicesModelsList(selectedDevicesModels);
  };

  handleSelectedDeviceTypeCategoriesChange = (selectedDeviceTypeCategories) => {
    this.setState((prevState, props) => ({
      selectedDeviceTypeCategories: [...selectedDeviceTypeCategories],
    }));
    let selectedDevicesModels = [];
    let _selectedDevicesList =
      this.state.selectedDevicesList.length !== 0 ? [...this.state.selectedDevicesList] : [...this.props.devicesList];

    let _selectedDevicesTypesOptions =
      selectedDeviceTypeCategories.length !== 0 ? selectedDeviceTypeCategories : [...this.props.deviceTypeCategories];
    if (selectedDeviceTypeCategories.length > 0) {
      _selectedDevicesList.forEach((selectedDevice) => {
        _selectedDevicesTypesOptions.forEach((slectedDeviceType) => {
          if (selectedDevice.device_model.deviceTypeCategory._id === slectedDeviceType._id) {
            this.props.devicesModels.forEach((deviceModel) => {
              if (selectedDevice.device_model._id === deviceModel._id)
                if (selectedDevicesModels.indexOf(deviceModel) === -1) selectedDevicesModels.push(deviceModel);
            });
          }
        });
      });
      this.props.SetSelectedDevicesModelsList(selectedDevicesModels);
      this.setState({
        selectedDeviceModelsList: [...[...intersection(this.state.selectedDeviceModelsList, selectedDevicesModels)]],
      });
    } else {
      this.handleClearDevicesFilters(true);
    }
  };

  handleSelectDevicesModelsOptionsChange = (selectedDevicesModelsOptions) => {
    this.setState({
      selectedDeviceModelsList: [...selectedDevicesModelsOptions],
    });
    // Opt-out early if the selected device models list is empty.
    if (selectedDevicesModelsOptions.length < 1) return this.handleClearDevicesFilters();
  };

  isFiltersEmpty = () => {
    return (
      this.state.selectedOrganizationList.length === 0 &&
      this.state.selectedDeviceModelsList.length === 0 &&
      this.state.selectedDeviceTypeCategories.length === 0
    );
  };

  handleApplyFilter = () => {
    if (this.isFiltersEmpty()) {
      this.props.fireErrorAlert(textTranslate("NoFiltersSelectedToApply"), {
        position: "bottom-right",
        effect: "flip",
      });
      this.handleClearDevicesFilters();
      return;
    }

    let filteredDevicesList = [];
    // If one or more Organizations are selected
    if (this.state.selectedOrganizationList.length > 0) {
      this.state.selectedOrganizationList.forEach((organization) => {
        let OrgDevices = this.getOrganizationDevices(organization);
        filteredDevicesList.push(...OrgDevices);
      });
    } else {
      // Use default list of All available devices
      filteredDevicesList = [...this.props.devices];
    }

    // If one or more DeviceTypes are selected
    if (this.state.selectedDeviceTypeCategories.length > 0) {
      let ids = this.state.selectedDeviceTypeCategories.map((t) => t._id);
      // Filter for devices that have at least one of the elements in the tags list above
      // filteredDevicesList = filteredDevicesList.filter((device) => some(device.device_model.tags, (tag) => includes(tags, tag)));
      filteredDevicesList = filteredDevicesList.filter((device) =>
        some(ids, (t) => t === device.device_model.deviceTypeCategory._id)
      );
    }

    // If one or more DeviceModels are selected
    if (this.state.selectedDeviceModelsList.length > 0) {
      let deviceModelIds = uniq(flattenDeep(this.state.selectedDeviceModelsList.map((m) => m._id)));
      filteredDevicesList = filteredDevicesList.filter((device) => includes(deviceModelIds, device.device_model._id));
    }
    // We need to remove duplicates!
    filteredDevicesList = uniqBy(filteredDevicesList, (d) => d._id);
    this.handleSelectDeviceOptionsChange(filteredDevicesList);
    toast(translate("filterApplied"));
  };

  handleSelectDeviceOptionsChange = (selectedDevices) => {
    if (selectedDevices.length > 0)
      Promise.all([this.props.setDevicesList(selectedDevices)])
        .then(this.props.StartDevicesFiltering())
        .then(this.props.setDevicesList(selectedDevices));
    else {
      this.props.setDevicesList(selectedDevices);
      this.props.fireErrorAlert(textTranslate("NoMatchingDevicesFound"), {
        position: "bottom-right",
        effect: "flip",
      });
    }
  };

  handleClearDevicesFilters = (isClearFields) => {
    this.props.clearDevicesFilters(
      this.props.devices,
      this.props.deviceTypeCategories,
      this.props.devicesModels,
      this.props.ability
    );

    if (isClearFields)
      this.setState({
        selectedOrganizationList: [],
        selectedDeviceModelsList: [],
        selectedDeviceTypeCategories: [],
      });
  };

  componentDidMount() {
    Promise.all([
      this.props.FetchAllOrganizationsList(),
      this.props.fetchDeviceTypeCategories(),
      this.props.FetchAllDevicesModelsList(),
    ]).then(this.props.FetchAllDevicesModelsList(this.props.deviceModel));
  }

  render() {
    const containerStyle = {
      zIndex: 999,
      marginTop: "40px",
    };
    return (
      <React.Fragment>
        <ToastContainer position="top-right" autoClose={1500} style={containerStyle} hideProgressBar />
        {this.state.isFilterOpen ? (
          <React.Fragment>
            <Row className="mb-2 ">
              <Col sm="12" md={{ size: 6 }} className="clear-fix">
                <Button
                  color="link"
                  className="pull-left"
                  onClick={() => {
                    this.setState({ isFilterOpen: false });
                  }}
                >
                  <i className="fa fa-minus mr-1" /> {translate("hideAdvancedFiltering")}
                </Button>
              </Col>
              <Col sm="12" md={{ size: 6 }} className="mb-2 clear-fix">
                <Button color="info" className="pull-right" onClick={this.handleApplyFilter}>
                  <i className="fa fa-filter" /> {translate("applyFilter")}
                </Button>
                <Button color="link" className="pull-right mr-4" onClick={() => this.handleClearDevicesFilters(true)}>
                  <i className="fa fa-eraser" /> {translate("clearFilter")}
                </Button>
              </Col>
              <Col sm="12" md="4" className="mt-1 d-flex flex-column">
                <Label className="text-muted mr-2">{translate("ownersLabel")}</Label>
                <Select
                  onChange={this.handleSelectOrganizationsOptionsChange}
                  value={this.state.selectedOrganizationList}
                  options={this.props.organizations}
                  className="w-100"
                  isMulti={true}
                  autoFocus
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option._id}
                />
              </Col>
              <Col sm="12" md="4" className="mt-1 d-flex flex-column">
                <Label className="text-muted mr-2">{translate("deviceTypesLabel")}</Label>
                <Select
                  onChange={this.handleSelectedDeviceTypeCategoriesChange}
                  value={this.state.selectedDeviceTypeCategories}
                  options={this.props.deviceTypeCategories}
                  className="w-100"
                  isMulti={true}
                  getOptionLabel={(option) => textTranslate(option.slug)}
                  getOptionValue={(option) => option._id}
                />
              </Col>
              <Col sm="12" md="4" className="mt-1 d-flex flex-column">
                <Label className="text-muted mr-2">{translate("devicesModelsLabel")}</Label>

                <Select
                  onChange={this.handleSelectDevicesModelsOptionsChange}
                  value={this.state.selectedDeviceModelsList}
                  options={this.props.devicesModelsList}
                  getOptionLabel={(option) => option.title}
                  getOptionValue={(option) => option._id}
                  className="w-100"
                  isMulti={true}
                />
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          <Row>
            <Col sm="12" md={{ size: 6 }} className="clear-fix">
              <Button
                color="link"
                className="pull-left"
                onClick={() => {
                  this.setState({ isFilterOpen: true });
                }}
              >
                <i className="fa fa-plus mr-1" /> {translate("showAdvancedFiltering")}
              </Button>
            </Col>
          </Row>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.devicesReducer.data,
  devices: state.devicesReducer.devices,
  devicesList: state.devicesReducer.devicesList,
  devicesModels: state.devicesReducer.devicesModels,
  devicesTypes: state.devicesReducer.devicesTypes,
  deviceTypeCategories: state.devicesReducer.deviceTypeCategories,
  devicesTypesList: state.devicesReducer.devicesTypesList,
  devicesModelsList: state.devicesReducer.devicesModelsList,
  organizations: state.organizationsReducer.organizations,
  selectedDeviceTypeCategories: state.devicesReducer.selectedDeviceTypeCategories,
  selectedDevices: state.devicesReducer.selectedDevices,
  selectedEndDate: state.devicesReducer.selectedEndDate,
  selectedStartDate: state.devicesReducer.selectedStartDate,
  language: state.i18nReducer.language,
  ability: state.usersReducer.ability,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...dashboardActions,
      ...i18nActions,
      ...deviceActions,
      ...organizationsActions,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(AdvancedFilter);
